export default "__VITE_ASSET__B_9i9Cuy__"